<template>
  <el-tooltip placement="top" :disabled="isDisableTooltip" :tabindex="-1">
    <el-select
      v-model="value"
      popper-append-to-body
      :placeholder="placeholder"
      :disabled="disabled"
      @change="handlerChange"
      :clearable="clearable"
      filterable
      :multiple-limit="multipleLimit"
      :multiple="multiple"
      :size="size"
      popper-class="mode-column"
      :filter-method="filterMethod"
      @focus="handlerFocus"
      @paste.native="handlePaste"
      ref="select">
      <template v-slot:prefix>
        <slot name="prefix">
        </slot>
      </template>
      <slot name="select-info" />
      <li class="mode-column__header">
        <div
          v-for="(column, i) in columns"
          :key="i"
          class="mode-column__header-item"
        >{{column.title}}</div>
      </li>
      <el-option
        v-for="item in showedData"
        :key="item[fields.id]"
        :label="getLabel(item)"
        :value="item[fields.id]"
        :disabled="!!item.disabled"
      >
        <template>
          <div class="mode-column__list">
            <div
              class="mode-column__list-item"
              v-for="(column, i) in columns"
              :key="i"
              :title="item[column.value]"
            >{{parseColumnValue(item, column)}}</div>
          </div>
        </template>
      </el-option>
    </el-select>
    <template v-slot:content>
      <div class="select-column-tooltip">
        <table>
          <tr
            v-for="(row, i) in tooltipItems"
            :key="i">
            <td class="select-column-tooltip__title">{{row.title}}</td>
            <td class="select-column-tooltip__value">{{row.value}}</td>
          </tr>
        </table>
      </div>
    </template>
  </el-tooltip>
</template>

<script>
import { select, selectColumns } from './mixins'
export default {
  name: 'DesktopColumns',
  mixins: [select, selectColumns]
}
</script>
